import { Button, EmptyState } from "@nodus/ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { OrgFrame } from "../../app/org-frame";
import { loadOrg } from "../../app/org-load";
import { lastScope } from "../../app/scope";

// `/account`: pages of the user, not of an org. They sit in the shell of `?org=`, else the last used org, so the rail
// and the connection line stay where the user came from.
export const Route = createFileRoute("/_authed/account")({
  validateSearch: (s: Record<string, unknown>): { org?: string } => (typeof s.org === "string" && s.org ? { org: s.org } : {}),
  loaderDeps: ({ search }) => ({ org: search.org }),
  loader: async ({ context, deps }) => {
    const userId = context.session.user.id;
    const orgs = await context.queryClient.fetchQuery({ queryKey: ["user", "orgs", userId], queryFn: context.api.organizations });
    if (orgs.length === 0) throw redirect({ to: "/onboarding" });
    const mine = (name: string | undefined) => (name && orgs.some((o) => o.metadata.name === name) ? name : undefined);
    return loadOrg(context, mine(deps.org) ?? mine(lastScope(userId).org) ?? orgs[0]!.metadata.name);
  },
  component: AccountLayout,
});

function AccountLayout() {
  const data = Route.useLoaderData();
  if (data.missing) {
    return (
      <main className="px-6 py-16">
        <EmptyState title="Organization not found" actions={<Button onClick={() => window.location.assign("/")}>Go to your organizations</Button>} />
      </main>
    );
  }
  return (
    <OrgFrame data={data}>
      <Outlet />
    </OrgFrame>
  );
}
